export default function About() {
  return (
    <div className="two-col">
      <div className="col-40" style={{ textAlign: 'right', paddingTop: 5 }}>
        <img
          src="/assets/alamar.jpeg"
          alt="ALAMAR schooner"
          style={{ maxWidth: '100%', height: 'auto' }}
        />
      </div>

      <div className="col-60">
        <h2>Exploring the Coast of Maine since 1947</h2>
        <hr style={{ margin: '10px 0' }} />
        <div className="paragraph">
          ALAMAR is a 45&apos; traditional sailing schooner built in 1947 by the Machiasport
          Boat Shop in Maine. She was never lofted. Instead, the builders worked from a
          carved half-model designed by Nathaniel French and Dan Stuart for Alamoosook
          Island Camp (&ldquo;AIC&rdquo;), located 15 miles north of Castine on an island in
          Alamoosook Lake.
        </div>
        <div className="paragraph">
          ALAMAR was designed with young campers in mind and this layout remains the same
          today. When the camp closed in the late 1960&apos;s, Lew Bigelow and Bob Richardson
          purchased the vessel and undertook needed repairs (which most of the purchase
          price was used to cover), along with the requirement they continue to maintain
          and keep the ship true to her original design and purpose. This included
          chartering her to families and friends who enjoyed sailing on an old-fashion
          schooner.
        </div>
        <div className="paragraph">
          In the time since, ALAMAR has undergone major rebuilds and repairs &ndash; primarily
          at Kenny Eaton&apos;s Boat Yard in Castine (1987&ndash;2000), which served as her home
          port and storage site over the winter.
        </div>
        <div className="paragraph">
          In 2011, Lew and Bob passed responsibility for ALAMAR&apos;s care to the Chase
          family. The Chases were involved with AIC and ALAMAR during her camp years, and
          never lost their appreciation for her charms. This fondness also found its way to
          the next generation. Beginning in 1990, Nigel Chase started taking camper-age
          groups of family and friends on ALAMAR adventures. This introduced many young
          Chase family members to ALAMAR and instilled in them a love of traditional wooden
          boats.
        </div>
        <div className="paragraph">
          With this history in mind, Lew asked Nigel if the Chase&apos;s would take
          responsibility for ALAMAR, knowing the family would give her a good home. In
          keeping with tradition, she was passed on for two dollars along with the pledge
          that her tradition be carried on in the years to come. So it is, that over six
          decades later, she continues to be kept and used in the same manner: providing
          young-at-heart adventurers the chance to put to sea in a simple, sturdy, and
          traditional way.
        </div>
      </div>
    </div>
  )
}
